import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('clickable-card', {
  slots: ['clickableOverlay'],
  variants: {
    skin: ['standard', 'shadow', 'outline', 'filled'],
  },
  states: ['hasPadding', 'disabled'],
});
